import React, { useEffect, useState } from "react";
import { Alert, Badge, Button, Spinner, Table } from "react-bootstrap";
import { basicAuth } from "../utils/Credentials";

const formatValue = (value) => {
  if (value === null || value === undefined || value === "") return "—";
  return typeof value === "object" ? JSON.stringify(value) : String(value);
};

const PartnerQuery = () => {
  const [queries, setQueries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [refresh, setRefresh] = useState(0);

  useEffect(() => {
    const controller = new AbortController();
    const fetchQueries = async () => {
      setLoading(true);
      setError("");
      try {
        const response = await fetch(
          "https://api.seobix.com/api/Partner/GetPartnerQuery",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Basic ${btoa(`${basicAuth.username}:${basicAuth.password}`)}`,
            },
            body: JSON.stringify({}),
            signal: controller.signal,
          },
        );
        if (!response.ok) {
          throw new Error(
            `Unable to load partner queries (${response.status}).`,
          );
        }
        const result = await response.json();
        if (String(result.status) !== "0") {
          throw new Error(result.msg || "Unable to load partner queries.");
        }
        if (
          !Array.isArray(result.data) ||
          result.data.some(
            (record) =>
              !record || typeof record !== "object" || Array.isArray(record),
          )
        ) {
          throw new Error("The server returned an unexpected response.");
        }
        if (!controller.signal.aborted) setQueries(result.data);
      } catch (err) {
        if (!controller.signal.aborted) {
          setError(
            err.message || "Unable to load partner queries. Please try again.",
          );
        }
      } finally {
        if (!controller.signal.aborted) setLoading(false);
      }
    };
    fetchQueries();
    return () => controller.abort();
  }, [refresh]);

  return (
    <section>
      <div className="d-flex justify-content-between align-items-center mb-4 gap-3">
        <h3 className="mb-0">Partner Query</h3>
        <Button
          onClick={() => setRefresh((value) => value + 1)}
          disabled={loading}
        >
          {error ? "Retry" : "Refresh"}
        </Button>
      </div>
      {error && <Alert variant="danger">{error}</Alert>}
      {loading ? (
        <div className="text-center py-5" role="status">
          <Spinner animation="border" size="sm" className="me-2" />
          Loading partner queries…
        </div>
      ) : (
        !error && (
          <div className="card shadow-sm">
            {queries.length === 0 ? (
              <p className="text-center text-muted p-5 mb-0">
                No partner queries found.
              </p>
            ) : (
              <Table responsive className="mb-0 ">
                <thead className="table-light">
                  <tr>
                    <th scope="col" className="text-nowrap">
                      Name
                    </th>
                    <th scope="col" className="text-nowrap">
                      Email
                    </th>

                    <th scope="col" className="text-nowrap">
                      Mobile
                    </th>
                    <th scope="col" className="text-nowrap">
                      Country
                    </th>
                    <th scope="col" className="text-nowrap">
                      Company
                    </th>
                    {/* <th scope="col" className="text-nowrap">Company Revenue</th> */}
                    <th scope="col" className="text-nowrap">
                      Industry
                    </th>
                    <th scope="col" className="text-nowrap">
                      Query
                    </th>
                    <th scope="col" className="text-nowrap">
                      Query At
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {queries.map((query, index) => (
                    <tr key={query.id ?? index}>
                      <td className="text-nowrap">
                        {formatValue(
                          [query.first_name, query.last_name]
                            .map((name) => (name ?? "").trim())
                            .filter(Boolean)
                            .join(" "),
                        )}
                      </td>

                      <td style={{ overflowWrap: "anywhere" }}>
                        {formatValue(query.work_email)}
                      </td>

                      <td className="text-nowrap">
                        {formatValue(query.phone_number)}
                      </td>
                      <td className="text-nowrap">
                        {formatValue(query.country_of_residence)}
                      </td>
                      <td>{formatValue(query.company)}</td>
                      {/* <td>{formatValue(query.company_revenue)}</td> */}
                      <td>{formatValue(query.industry)}</td>
                      <td
                        style={{
                          minWidth: "250px",
                          maxWidth: "450px",
                          whiteSpace: "pre-wrap",
                          overflowWrap: "anywhere",
                        }}
                      >
                        {formatValue(query.help_text)}
                      </td>
                      <td className="text-nowrap">
                        {formatValue(query.submitted_at)}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            )}
          </div>
        )
      )}
    </section>
  );
};

export default PartnerQuery;
